import type { TollFreeRegistrationModel } from '@src/service/model'

import Repository from './base'

export const TOLL_FREE_REGISTRATION_TABLE_NAME = 'tollFreeRegistration'

export default class TollFreeRegistrationRepository extends Repository<TollFreeRegistrationModel> {}
